<script setup>
const props = defineProps(['to', 'hash', 'href', 'disabled', 'processing', 'icon', 'target', 'withoutEdge'])
</script>

<template>
	<a class="btn label-medium group" v-if="href" :href="href" :target="target ?? '_blank'">
		<slot></slot>
		<div class="icon flex h-5 w-5 items-center justify-center rounded-full" v-if="icon">
			<i :class="icon"></i>
		</div>
		<i v-if="!withoutEdge" class="icon-button-edge absolute bottom-1 right-1 text-[6px] transition-all" />
	</a>
	<router-link class="btn label-medium group" v-else-if="to" :to="to">
		<slot></slot>
		<div class="icon flex h-5 w-5 items-center justify-center rounded-full" v-if="icon">
			<i :class="icon"></i>
		</div>
		<i v-if="!withoutEdge" class="icon-button-edge absolute bottom-1 right-1 text-[6px] transition-all" />
	</router-link>
	<button class="btn label-medium group" v-else :disabled="disabled">
		<i class="fas fa-circle-notch fa-spin group animate-spin" v-if="processing"></i>
		<slot v-else></slot>
		<div class="icon flex h-5 w-5 items-center justify-center rounded-full" v-if="icon">
			<i :class="icon"></i>
		</div>
		<i v-if="!withoutEdge" class="icon-button-edge absolute bottom-1 right-1 text-[6px] transition-all" />
	</button>
</template>

<style scoped>
.btn {
	@apply flex flex-row items-center justify-center gap-1 rounded-small px-4 py-[10px] font-proto leading-4 tracking-normal transition-all duration-300;
}

.btn:hover .icon-button-edge {
	@apply bottom-1.5 right-1.5;
}

.btn.outlined:disabled {
	@apply opacity-30 hover:border-default hover:text-default;
}
/* Variants */
.btn.default {
	@apply relative bg-paper-light text-black hover:bg-default;
}
.btn.outlined {
	@apply relative border border-default hover:border-paper-darker hover:text-paper-darker;
}

.btn.close {
	@apply h-[2rem] w-[2rem] bg-border-default hover:bg-neutral-500;
}
.btn:disabled {
	@apply opacity-20;
}
</style>
